"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOutcomeLoadingStatus = void 0;
const react_redux_1 = require("react-redux");
const react_1 = require("react");
const selectors_1 = require("../selectors");
const utils_1 = require("../utils");
const useOutcomeLoadingStatus = ({ eventId, outcomeTypeId, parameters, }) => {
    const outcomeKey = (0, react_1.useMemo)(() => {
        if (!eventId || !outcomeTypeId || !parameters)
            return undefined;
        return (0, utils_1.getBasketOutcomeKey)({
            probability: {
                outcomeTypeId,
                parameters,
            },
            event: { id: eventId },
        });
    }, [eventId, outcomeTypeId, parameters]);
    return (0, react_redux_1.useSelector)((state) => {
        if (!outcomeKey)
            return false;
        return (0, selectors_1.makeSelectIsOutcomeLoading)(state, outcomeKey);
    });
};
exports.useOutcomeLoadingStatus = useOutcomeLoadingStatus;
//# sourceMappingURL=useOutcomeLoadingStatus.js.map